import React from 'react';
import IntlMessages from '../../../util/IntlMessages';

interface ICatalogueActionBarProps {
  selectedCount: number;
  isSaving: boolean;
  saveError: string;
  onDiscard: () => void;
}

const CatalogueActionBar: React.FC<ICatalogueActionBarProps> = ({
  selectedCount,
  isSaving,
  saveError,
  onDiscard,
}) => (
  <div className='group-catalogue__action-bar'>
    <div className='group-catalogue__actions'>
      {saveError && <div className='group-catalogue__save-error'>{saveError}</div>}
      <div className='group-catalogue__button-row'>
        <button
          type='button'
          className='jr-btn-default-outlined'
          onClick={onDiscard}
          disabled={isSaving}
        >
          <IntlMessages id='groups.catalogue.discard' />
        </button>
        <button
          type='submit'
          className='jr-btn-default'
          disabled={selectedCount === 0 || isSaving}
        >
          {isSaving ? 'Creating' : `Create ${selectedCount} group${selectedCount === 1 ? '' : 's'}`}
        </button>
      </div>
    </div>
  </div>
);

export default CatalogueActionBar;
